import { optionTitle_VoiceMail } from './VoiceMailOption.locstring.json';
import VoiceMailOption from './VoiceMailOption';
import { OptionSubCategory } from 'owa-options-core';

let unifiedMessagingSubCategory: OptionSubCategory = {
    key: 'unifiedmessaging',
    titleStringKey: optionTitle_VoiceMail,
    options: [VoiceMailOption],
};

export default unifiedMessagingSubCategory;
